module.exports = __webpack_public_path__ + "static/media/me.00ceb0a2.jpg";